import React from "react";
import Main from "./Main";
import Dowload from "./Dowload";
import Footer from "./Footer";
import Navbar from "../component/Navbar";
import "./indexhome.css";

const IndexHome = () => {
  return (
    <div className="indexmain">
      <Navbar />
      <Main />
      <Dowload />
      <Footer />
    </div>
  );
};

export default IndexHome;
